<template>
    <div class="content_box mobile_content">
        <div class="content user">
            <div class="title_box">
                <div class="title_name">
                    <span class="title">成员列表</span>
                    <el-tooltip popper-class="shadow" effect="light" content="成员列表的成员为【飞书自建应用-获取通讯录权限范围】内的成员" placement="bottom-start">
                        <img class="icon-tip" src="../../assets/images/ico/ic_tip.png" alt=""> 
                    </el-tooltip>
                </div>
                <span class="reload_user" @click="syncUser" v-if="roleCheck('190-101-101-103')">
                    <i class="el-icon-refresh"></i>
                    <span>同步</span>
                </span>
            </div>
            <div class="search_box">
                <el-form :inline="true" :model="searchData" class="demo-form-inline search-form" label-width="90px">
                    <el-form-item label="关键字：">
                        <el-input v-model="searchData.keyword" placeholder="姓名/手机号/邮箱"></el-input>
                    </el-form-item>
                    <el-form-item label="角色：">
                        <el-select clearable v-model="searchData.role_id" placeholder="请选择">
                            <el-option :label="item.role_name" :value="item.role_id" v-for="item in role" :key="item.role_id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="启用状态：">
                        <el-select v-model="searchData.is_fail" placeholder="请选择">
                            <el-option label="全部状态" :value="2"></el-option>
                            <el-option label="开" :value="0"></el-option>
                            <el-option label="关" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-table
                highlight-current-row
                :data="listData"
                style="width: 100%">
                <el-table-column prop="user_name" label="成员姓名"></el-table-column>
                <el-table-column prop="gender" label="性别">
                    <template slot-scope="scope">
                        <span v-if="scope.row.gender == 0">--</span>
                        <span v-if="scope.row.gender == 1">男</span>
                        <span v-if="scope.row.gender == 2">女</span>
                    </template>
                </el-table-column>
                <el-table-column prop="phone" label="手机号" min-width="130px">
                    <template slot-scope="scope">
                        <span>{{scope.row.phone || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="email" label="邮箱" min-width="200px">
                    <template slot-scope="scope">
                        <span>{{scope.row.email || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="角色" min-width="120px">
                    <template slot-scope="scope">
                        <span>{{scope.row.roles.join('；')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="启用状态">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.is_fail"
                            :disabled="!roleCheck('190-101-101-102')"
                            :width="40"
                            inactive-color="#ccc"
                            :active-value="0"
                            :inactive-value="1"
                            @change="statusChange(scope.row)"
                        >
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <div class="button text" @click="updateRole(scope.row)" v-if="roleCheck('190-101-101-102')">更换角色</div>
                        <div class="button text del_btn" @click="delUser(scope.row)" v-if="roleCheck('190-101-101-104')">删除</div>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
            <Tip ref="tip" :msg="tip.msg" @tipBack="delUserConfirm"></Tip>
            <Tip ref="status" :msg="tip.statusMsg" :title="tip.title">
                <template v-slot:confirm_btn>
                    <div class="button del" @click="statusChangeConfirm">
                        <span>确定</span>
                    </div>
                </template>
            </Tip>
            <Gh-Dialog ref="updateRole" title="更换成员角色" @dialogBack="updateConfirm">
                <template v-slot:content>
                    <el-form label-width="100px">
                        <el-form-item label="成员姓名:">
                            <span>{{actUserInfo.user_name}}</span>
                        </el-form-item>
                        <el-form-item label="关联角色:">
                            <el-select v-model="actUserInfo.roleIds" multiple placeholder="请选择">
                                <el-option :label="item.role_name" :value="item.role_id" v-for="item in role" :key="item.role_id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>

export default({
    name: 'user',
    data() {
        return {
            role: '',
            searchData: {
                keyword: '',
                role_id: '',
                is_fail: 2,
                page_size: 10,
                page: 1
            },
            total: 0,
            listData: [],
            actUserInfo: {},
            user_id: '', //当前操作用户的id
            tip: {
                msg: '',
                statusMsg: ''
            },
        }
    },
    created() {
        this.getRole();
        this.getUser();
    },
    methods: {
        search() {
            this.searchData.page = 1;
            this.getUser();
        },
        getRole() {
            this.api.getRole({}).then(data => {
                this.role = data.data.roleList;
            })
        },
        syncUser() {
            this.api.syncUser({}).then(data => {
                this.getUser();
            })
        }, 
        getUser() {
            this.api.getUser(this.searchData).then(data => {
                this.listData = data.data.userList;
                this.total = data.data.total;
            })
        },
        statusChange(item) {
            this.actUserInfo = item;
            this.actUserInfo.is_fail = this.actUserInfo.is_fail ? 0 : 1;
            this.tip.statusMsg = '确定要停用选中的成员账号吗？';
            this.tip.title = '账号停用提示';
            if(this.actUserInfo.is_fail == 1) {
                this.tip.title = '账号激活提示';
                this.tip.statusMsg = '确定要激活选中的成员账号吗？';
            }
            this.$refs.status.show = true;
        },
        statusChangeConfirm() {
            this.actUserInfo.is_fail = this.actUserInfo.is_fail ? 0 : 1;
            this.api.updateUser({user_id: this.actUserInfo.user_id, is_fail: this.actUserInfo.is_fail});
            this.$refs.status.show = false;
        },
        updateRole(item) {
            this.actUserInfo = {...item};
            this.$refs.updateRole.show = true;
        },
        updateConfirm() {
            if(this.actUserInfo.roleIds.length == 0) {
                this.$message.warning('请分配角色！');
                return 1;
            }
            this.api.updateUser({user_id: this.actUserInfo.user_id, is_fail: -1, roleIds: this.actUserInfo.roleIds}).then(data => {
                this.$message.success('修改成功！');
                this.$refs.updateRole.show = false;
                this.getUser();
            });
        },
        delUser(item) {  //删除成员之前需要先确定该成员下是否有工单任务
            this.tip.msg = '确定要删除该成员吗？';
            this.$refs.tip.show = true;
            this.user_id =  item.user_id;
        },
        delUserConfirm() {
            this.api.delUser({user_id: this.user_id}).then(data => {
                this.$message.success('删除成功！');
                this.getUser();
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getUser();
        }
    }
})
</script>
<style lang="less" scoped>
    .user{
        .title_box{
            .flexLayout(flex-start);
            .title_name{
                .flexLayout(flex-start);
                img{
                    width: 20px;
                    margin-left: 5px;
                    margin-top: -4px;
                    cursor: pointer;
                }
                .title{
                    cursor: pointer;
                }
            }
            
            .reload_user{
                font-size: 16px;
                padding-left: 12px;
                color: @colorBlue;
                cursor: pointer;
                span{
                    font-size: 14px;
                    color: @color999;
                }
            }
        }
        .search_box{
            .el-form-item{
                margin-right: 3%;
                &:last-child{
                    margin-right: 0;
                }
            }
        }
    }
    @media (max-width: 768px) {
        .user{
            /deep/.search_box{
                .el-form-item{
                    .el-form-item__label{
                        font-size: 0.12rem;
                    }
                    .el-input{
                        width: 200px;
                    }
                    .el-input__inner{
                        min-width: 160px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/settings/user.vue